import {Component} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ToastService} from "@services";

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [
    trigger('toastTrigger', [
      state('open', style({transform: 'translateY(0%)'})),
      state('close', style({transform: 'translateY(-300%)'})),
      transition('open <=> close', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})

export class ToastComponent {
  constructor(public toastService: ToastService) {
  }

  dismiss(): void {
    this.toastService.dismissToast();
  }
}
